document.addEventListener('DOMContentLoaded', function() {
    const drawer = document.getElementById('drawer');
    const closeButton = document.getElementById('close-drawer');
    const addToCartButton = document.getElementById('add-to-cart-button');
    const nutritionTab = document.getElementById('nutrition-tab');
    const physicalTab = document.getElementById('physical-tab');
    const attributesTab = document.getElementById('attributes-tab');
    const nutritionSection = document.getElementById('nutrition-section');
    const physicalSection = document.getElementById('physical-section');
    const attributesSection = document.getElementById('attributes-section');
    const listViewBtn = document.getElementById('list-view');
    const gridViewBtn = document.getElementById('grid-view');
    const nutritionContainer = document.getElementById('nutrition-container');
    const ingredientItems = document.querySelectorAll('.ingredient-item');
    const searchInput = document.querySelector('input[type="text"]');

    // Function to hide drawer with robust checks
    function hideDrawer() {
        if (drawer) {
            // Apply multiple hiding methods
            drawer.style.display = 'none';
            drawer.classList.add('hidden');
            drawer.style.visibility = 'hidden';
            drawer.style.opacity = '0';
            // Check computed style to confirm hiding
            const computedStyle = window.getComputedStyle(drawer);
            console.log('Drawer hidden, computed display:', computedStyle.display, 'visibility:', computedStyle.visibility, 'at', new Date().toISOString());
            // Reset to first tab for next open
            if (nutritionTab && nutritionSection) {
                activateTab(nutritionTab, nutritionSection);
                console.log('Reset to Nutrition Summary tab on drawer close at', new Date().toISOString());
            }
            // Reload the page after a short delay to ensure drawer hides first
            console.log('Initiating page reload on drawer close at', new Date().toISOString());
            setTimeout(() => {
                window.location.reload();
            }, 300); // 300ms delay to allow CSS transitions to complete
        } else {
            console.error('Drawer element (#drawer) not found. Check HTML for id="drawer".');
        }
    }

    // Function to activate a tab
    function activateTab(tab, section) {
        if (tab && section) {
            [nutritionSection, physicalSection, attributesSection].forEach(s => {
                if (s) s.classList.add('hidden');
            });
            [nutritionTab, physicalTab, attributesTab].forEach(t => {
                if (t) {
                    t.classList.remove('text-gray-900', 'border-b-2', 'border-gray-900');
                    t.classList.add('text-gray-500');
                    t.style.borderBottom = '2px solid transparent';
                }
            });
            section.classList.remove('hidden');
            tab.classList.add('text-gray-900', 'border-b-2', 'border-gray-900');
            tab.classList.remove('text-gray-500');
            tab.style.borderBottom = '2px solid #111827';
            console.log('Activated tab:', tab.textContent, 'at', new Date().toISOString());
        }
    }

    // Initialize first tab on page load
    if (nutritionTab && nutritionSection) {
        activateTab(nutritionTab, nutritionSection);
        console.log('Initialized Nutrition Summary tab on page load at', new Date().toISOString());
    } else {
        console.error('Nutrition tab or section not found. Check HTML for id="nutrition-tab" and id="nutrition-section".');
    }

    // Observe drawer visibility to auto-open first tab
    if (drawer && nutritionTab && nutritionSection) {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'style') {
                    const display = window.getComputedStyle(drawer).display;
                    if (display === 'block') {
                        activateTab(nutritionTab, nutritionSection);
                        console.log('Drawer opened, auto-activated Nutrition Summary tab at', new Date().toISOString());
                    }
                }
            });
        });
        observer.observe(drawer, { attributes: true, attributeFilter: ['style'] });
    } else {
        console.error('Cannot set up observer: drawer, nutrition-tab, or nutrition-section missing.');
    }

    // Close button handler
    if (closeButton) {
        closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            console.log('Close button clicked at', new Date().toISOString());
            // Disable button temporarily to prevent rapid clicks
            closeButton.disabled = true;
            hideDrawer();
            // Re-enable button after a short delay
            setTimeout(() => {
                closeButton.disabled = false;
                console.log('Close button re-enabled at', new Date().toISOString());
            }, 300);
        });
    } else {
        console.error('Close button (#close-drawer) not found. Check HTML for id="close-drawer".');
    }

    // Drawer background click to close
    if (drawer) {
        drawer.addEventListener('click', (e) => {
            if (e.target === drawer) {
                console.log('Drawer background clicked at', new Date().toISOString());
                hideDrawer();
            }
        });
    } else {
        console.error('Drawer element (#drawer) not found');
    }

    // Add to cart handler
    if (addToCartButton) {
        addToCartButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            console.log('Add to cart button clicked at', new Date().toISOString());

            // Get variant ID dynamically or use fallback
            const form = document.querySelector('form[action="/cart/add"]');
            const variantId = form && form.querySelector('input[name="id"]') ? form.querySelector('input[name="id"]').value : '45820713378081';
            const quantity = 1;

            // Disable button to prevent multiple clicks
            addToCartButton.disabled = true;
            addToCartButton.textContent = 'Adding...';

            // Shopify AJAX API request
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    items: [{
                        id: variantId,
                        quantity: quantity
                    }]
                })
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                if (data.status) {
                    console.error('Error adding to cart:', data.description);
                    alert('Failed to add item to cart: ' + data.description);
                } else {
                    console.log('Item added to cart successfully, variant ID:', variantId);
                    // Hide ingredient drawer
                    hideDrawer();
                    // Open AJAX cart drawer
                    const cartDrawerSelectors = [
                        '#cart-drawer',
                        '.cart-drawer',
                        '#shopify-section-cart-drawer',
                        '.ajax-cart',
                        '[data-ajax-cart-section]',
                        '#CartDrawer'
                    ];
                    let cartDrawer = null;
                    for (const selector of cartDrawerSelectors) {
                        cartDrawer = document.querySelector(selector);
                        if (cartDrawer) break;
                    }
                    if (cartDrawer) {
                        cartDrawer.style.display = 'block';
                        cartDrawer.classList.remove('hidden');
                        console.log('Cart drawer opened using selector:', cartDrawerSelectors.find(sel => document.querySelector(sel)));
                    } else {
                        console.warn('Cart drawer not found, tried selectors:', cartDrawerSelectors);
                        // Try Shopify theme events
                        const cartEvents = ['cart:open', 'ajaxCart.show', 'cart:toggle', 'shopify:cart:open'];
                        cartEvents.forEach(event => {
                            document.dispatchEvent(new CustomEvent(event));
                            console.log('Dispatched event:', event);
                        });
                    }
                    // Update cart count
                    document.dispatchEvent(new CustomEvent('cart:updated'));
                    // Show success message and refresh page
                    alert('Product added to cart successfully!');
                    console.log('Initiating page refresh after 1-second delay at', new Date().toISOString());
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                }
            })
            .catch(error => {
                console.error('Error adding to cart:', error);
                alert('An error occurred while adding to cart. Please try again.');
            })
            .finally(() => {
                // Re-enable button
                addToCartButton.disabled = false;
                addToCartButton.textContent = 'ADD TO CART | $ 22.00';
            });
        });
    } else {
        console.error('Add to cart button (#add-to-cart-button) not found');
    }

    // Tab switching
    if (nutritionTab) {
        nutritionTab.addEventListener('click', () => activateTab(nutritionTab, nutritionSection));
    }
    if (physicalTab) {
        physicalTab.addEventListener('click', () => activateTab(physicalTab, physicalSection));
    }
    if (attributesTab) {
        attributesTab.addEventListener('click', () => activateTab(attributesTab, attributesSection));
    }

    // View toggling
    function setViewMode(mode) {
        if (mode === 'list') {
            nutritionContainer.classList.remove('grid', 'grid-cols-2', 'gap-4', 'space-y-1');
            nutritionContainer.classList.add('space-y-0');
            ingredientItems.forEach((item) => {
                item.classList.add('border-b', 'border-gray-100', 'w-full');
                item.classList.remove('border', 'shadow-sm', 'bg-white', 'rounded-lg');
                const header = item.querySelector('.flex.items-center.justify-between');
                header.classList.remove('py-2', 'px-2', 'hover:bg-gray-50', 'rounded');
                header.classList.add('py-1.5', 'px-0', 'hover:bg-gray-50/50');
                const content = item.querySelector('.hidden');
                if (content) {
                    content.classList.remove('px-4', 'py-3');
                    content.classList.add('px-2', 'py-2', 'ml-6');
                }
            });
            listViewBtn.classList.add('bg-primary', 'text-white');
            listViewBtn.classList.remove('hover:bg-gray-50', 'text-gray-600');
            listViewBtn.style.borderBottom = '1px solid #81459e';
            gridViewBtn.classList.remove('bg-primary', 'text-white');
            gridViewBtn.classList.add('hover:bg-gray-50', 'text-gray-600');
            gridViewBtn.style.borderBottom = '1px solid #d1d5db';
        } else {
            nutritionContainer.classList.remove('space-y-0');
            nutritionContainer.classList.add('grid', 'grid-cols-2', 'gap-4', 'space-y-1');
            ingredientItems.forEach((item) => {
                item.classList.remove('border-b', 'border-gray-100', 'w-full');
                item.classList.add('border', 'border-gray-200', 'shadow-sm', 'bg-white', 'rounded-lg');
                const header = item.querySelector('.flex.items-center.justify-between');
                header.classList.add('py-2', 'px-2', 'hover:bg-gray-50', 'rounded');
                header.classList.remove('py-1.5', 'px-0', 'hover:bg-gray-50/50');
                const content = item.querySelector('.hidden');
                if (content) {
                    content.classList.remove('px-2', 'py-2', 'ml-6');
                    content.classList.add('px-4', 'py-3');
                }
            });
            gridViewBtn.classList.add('bg-primary', 'text-white');
            gridViewBtn.classList.remove('hover:bg-gray-50', 'text-gray-600');
            gridViewBtn.style.borderBottom = '1px solid #81459e';
            listViewBtn.classList.remove('bg-primary', 'text-white');
            listViewBtn.classList.add('hover:bg-gray-50', 'text-gray-600');
            listViewBtn.style.borderBottom = '1px solid #d1d5db';
        }
    }

    if (listViewBtn && gridViewBtn) {
        listViewBtn.addEventListener('click', () => setViewMode('list'));
        gridViewBtn.addEventListener('click', () => setViewMode('grid'));
        setViewMode('list');
    }

    // Ingredient item expansion
    ingredientItems.forEach((item) => {
        const header = item.querySelector('.flex.items-center.justify-between');
        const content = item.querySelector('.hidden');
        const arrow = item.querySelector('i');
        if (header && content && arrow) {
            header.addEventListener('click', () => {
                const isExpanded = !content.classList.contains('hidden');
                content.classList.toggle('hidden');
                arrow.classList.toggle('ri-arrow-right-s-line', isExpanded);
                arrow.classList.toggle('ri-arrow-down-s-line', !isExpanded);
            });
        }
    });

    // Search functionality
    if (searchInput) {
        searchInput.addEventListener('input', () => {
            const searchTerm = searchInput.value.toLowerCase();
            ingredientItems.forEach((item) => {
                const ingredientText = item.querySelector('span').textContent.toLowerCase();
                item.style.display = ingredientText.includes(searchTerm) ? 'block' : 'none';
            });
        });
    }

    // Debug script loading
    console.log('ingredient-drawer.js loaded at', new Date().toISOString());
});